import * as React from "react";

import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import mediaUrl from "../../util/mediaUrl";

type ClubType = "home" | "connected";

interface ClubCardProps {
    clubType: ClubType;
    providerName: string;
    providerLabel: string;
    onClick: () => void;
}

const DescriptiveText: Record<ClubType, string> = {
    home: "Your home club workouts",
    connected: "Workouts from the trainer's club",
};

export default function ClubCard({
    clubType,
    providerName,
    providerLabel,
    onClick,
}: ClubCardProps): React.JSX.Element {
    const avatarUrl = mediaUrl(`publisher-avatars/${providerName}.png`);

    return (
        <Box
            onClick={onClick}
            sx={{
                backgroundColor: "#243049",
                borderRadius: "12px",
                padding: "10px",
                display: "flex",
                alignItems: "center",
                gap: "15px",
                cursor: "pointer",
                transition: "background 0.2s",
                opacity: 0.75,
                "&:active": {
                    backgroundColor: "#26334d",
                },
            }}
        >
            <Box
                sx={{
                    width: 30,
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <Avatar
                    src={avatarUrl}
                    alt={providerLabel}
                    sx={{
                        backgroundColor: "white",
                        width: 30,
                        height: 30,
                    }}
                    variant="square"
                />
            </Box>
            <Stack spacing={0.25}>
                <Typography
                    variant="body1"
                    sx={{
                        color: "white",
                        fontWeight: 700,
                        fontSize: "1.1rem",
                    }}
                >
                    {providerLabel}
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        color: "#94a3b8",
                        fontSize: "0.8rem",
                        fontWeight: 400,
                    }}
                >
                    {DescriptiveText[clubType]}
                </Typography>
            </Stack>
        </Box>
    );
}
